import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CmpFacturacionComponent } from '../componentes/cmp-facturacion/cmp-facturacion.component';



import { CajaComponent } from "./caja/caja.component";
import { AdminCajaComponent } from "./admin-caja/admin-caja.component";
import { FacturacionComponent } from "./facturacion/facturacion.component";
import { PromocionesComponent } from "./promociones/promociones.component";
import { ReportesComponent } from "./reportes/reportes.component";
import { MedioPagosComponent } from "../componentes/medio-pagos/medio-pagos.component";
import { ConciliacionComponent } from '../componentes/conciliacion/conciliacion.component';
//import { AguaBuscaCuentasComponent } from "../componentes/agua-busca-cuentas/agua-busca-cuentas.component";
import { CobrosComponent } from "../componentes/cobros/cobros.component";
import { DatosFiscalesComponent } from "../ingresos/datos-fiscales/datos-fiscales.component";

import { AuthGuard } from 'app/_helpers/auth.guard';




const routes: Routes = [
  
  {
    path: "",
    children: [
      {
 
        path: "MedioPagos",
        component: MedioPagosComponent,
        canActivate: [AuthGuard]
        
        
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "caja",
        component: CajaComponent,
          canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "admin-caja",
        component: AdminCajaComponent,
          canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "facturacion",
        component: FacturacionComponent,
          canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "conciliacion",
        component: ConciliacionComponent,
          canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "datos-fiscales",
        component: DatosFiscalesComponent,
          canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "promociones",
        component: PromocionesComponent,
          canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "reportes",
        component: ReportesComponent,
          canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
        {
            path: "CmpFacturacion",
        component: CmpFacturacionComponent,
              canActivate: [AuthGuard]
        }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "cobros",
        component: CobrosComponent,
        canActivate: [AuthGuard]
      }
    ]
  },
  

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IngresosRoutingModule {}
